module.exports = __webpack_public_path__ + "img/Unit_Guide_double.cb355de2.svg";